import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <MediaSection />
        <AppSection />
        <TopicsSection />
        <FeaturesSection />
        <IndexSection />
        <UpdatesSection />
        <RankingSection />
        <CommentsSection />
        <CardsSection />
        <ContactSection />
        <FaqSection />
        <CarouselSection />
      </main>
      <Footer />
    </div>
  );
}